module.exports = __webpack_public_path__ + "static/media/loader.580040e4.svg";